'use strict';

/**
 * Component for the dimensions
 *
 * @category   View
 * @module     collection.edit
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var LayoutView = require('base/Colido.LayoutView');

var template = require('../../templates/components/field-dimensions.hbs');

var DimensionsComponent = LayoutView.extend({
    template: template,

    className: function() {
        var field = this.getOption('field');

        return 'form-component component-' + _.camelToHyphen(field.type);
    },

    ui: {
        'sizeInput': '.input-size-width, .input-size-height, .input-size-depth',
        'sizeInputWidth': '.input-size-width',
        'sizeInputHeight': '.input-size-height',
        'sizeInputDepth': '.input-size-depth',
        'selectSizeUnit': '.select-size-unit',
    },

    events: {
        'keyup @ui.sizeInput': 'sizeInputChanged',
        'keydown @ui.sizeInput': 'sizeInputChanged',
        'change @ui.selectSizeUnit': 'sizeInputChanged',
    },

    viewData: {
        field: function() {
            return this.getOption('field');
        },

        widthField: function() {
            return this.widthField
        },

        heightField: function() {
            return this.heightField
        },

        depthField: function() {
            return this.depthField
        },

        unitField: function() {
            return this.unitField
        },

        typeField: function() {
            return this.typeField
        },

        isGroupChild: function() {
            return this.getOption('isGroupChild');
        },
    },

    initialize: function() {
        var field = this.getOption('field');
        var sourceFields = field.sourceFields;
        var catalog = this.model.collection.catalog;

        this.widthField = catalog.getFieldDefinition(sourceFields.width);
        this.heightField = catalog.getFieldDefinition(sourceFields.height);
        this.depthField = catalog.getFieldDefinition(sourceFields.depth);
        this.unitField = catalog.getFieldDefinition(sourceFields.unit);
        this.typeField = catalog.getFieldDefinition(sourceFields.type);
    },

    /**
     * Resets the states and data of the component
     */
    reset: function() {
        // Render basic size unit
        this.renderSelectOptions(
            this.ui.selectSizeUnit,
            App.BaseModule.sizeUnitsCollection,
            'key',
            'key',
            function(option) {
                return this.model && this.model.get(this.unitField.name) == option.value;
            }.bind(this)
        );

        if (this.typeField) {
            this.switchDimensionType(this.model.get(this.typeField.name));
        }
    },

    onShow: function() {
        this.reset();
    },

    /**
     * Changes the dimension type based on the height and width
     */
    sizeInputChanged: function() {
        var width = parseFloat(this.ui.sizeInputWidth.val().replace(',', '.')) || 1;
        var height = parseFloat(this.ui.sizeInputHeight.val().replace(',', '.')) || 1;
        var unit = this.ui.selectSizeUnit.val();

        if (width > 0 && height > 0) {
            var dimensionType = this.model.getDimensionType(width, height, unit); //@todo make 3 dimensional
            this.switchDimensionType(dimensionType);
        }
    },

    switchDimensionType: function(dimensionType) {
        if (this.typeField) {
            this.$('#dimensionType' + _.ucfirst(dimensionType)).prop('checked', true);
        }
    },

    getData: function() {
        var data = {};
        var field = this.getOption('field');

        data[this.widthField.name] = this.$('[name="' + this.widthField.name + '"]').val().trim();
        data[this.heightField.name] = this.$('[name="' + this.heightField.name + '"]').val().trim();
        data[this.depthField.name] = this.$('[name="' + this.depthField.name + '"]').val().trim();
        data[this.unitField.name] = this.$('[name="' + this.unitField.name + '"]').val().trim();

        if (this.typeField) {
            data[this.typeField.name] = this.$('[name="' + this.typeField.name + '"]:checked').val();
        }

        return data;
    },
});

module.exports = DimensionsComponent;